export enum EFileStatus {
  Pending = 'Pending',
  Uploading = 'Uploading',
  Uploaded = 'Uploaded',
  Error = 'Error'
}

/** Attachment mode for split menu - 'media' for images/videos, 'files' for documents */
export type AttachmentMode = 'media' | 'files' | null;

/** Accept config for media files (images + videos) */
export const mediaAccept = {
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'image/gif': ['.gif'],
  'image/heic': ['.heic'],
  'video/mp4': ['.mp4'],
  'video/x-ms-wmv': ['.wmv'],
  'video/x-msvideo': ['.avi']
};

/** Accept config for document files */
export const filesAccept = {
  'application/pdf': ['.pdf'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/msword': ['.doc'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.ms-powerpoint': ['.ppt'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
  'text/plain': ['.txt']
};

/** Accept config for all file types (fallback) */
export const fullAccept = {
  'application/pdf': ['.pdf'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/msword': ['.doc'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.ms-powerpoint': ['.ppt'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
  'text/plain': ['.txt'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'image/gif': ['.gif'],
  'image/heic': ['.heic'],
  'video/mp4': ['.mp4'],
  'video/x-ms-wmv': ['.wmv'],
  'video/x-msvideo': ['.avi']
};
